export default "/images/2c831485cde11481ac0eadc93234692c.avif";